// Minimum on-screen width for an axis tick. When even the coarse unit (year/quarter)
// would compress below this, the chart grows past the container and scrolls horizontally
// instead of collapsing into unreadable columns.
export const MIN_TICK_WIDTH = 56;

// Minimum width for a phase bar so short (or zero-duration) phases still show their label.
export const MIN_BAR_WIDTH = 140;
